'use strict';

var XTFormConfig = function XTFormConfig(xtFormConfigProvider) {
  xtFormConfigProvider.addValidationStrategy('submittedOrTouched', function (form, ngModel) {
    return ngModel.$invalid && ngModel.$focused && (ngModel.$touched || form.$submitted);
  });
  xtFormConfigProvider.setErrorMessages({
    required: 'Please complete the required field',
    number: 'Illegal value',
    pattern: 'Illegal value',
    duplicated: 'duplicated value',
    invalidDate: 'The value must be a value date.'
  });
};
XTFormConfig.$inject = ['xtFormConfigProvider'];
module.exports = XTFormConfig;